import { useEffect, useRef, useState } from 'react';
import sharedStyles from '../TextArea.module.scss';

interface ITextAreaInput {
  value: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: string) => void;
  name?: string;
  label?: string;
  variant?: 'fullSize' | 'halfSize';
  className?: string;
  rows?: number;
}

function TextAreaInput({ value, onChange, name, label, variant = 'fullSize', className, rows = 5 }: ITextAreaInput) {
  const textareaId = name || 'tour-app-textarea';
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [showScrollbar, setShowScrollbar] = useState(false);

  useEffect(() => {
    const el = inputRef.current;
    if (el) {
      // Compare the actual scroll height with the visible height
      setShowScrollbar(el.scrollHeight > el.clientHeight);
    }
  }, [value]);

  return (
    <div className={`${sharedStyles.textAreaWrapper} ${sharedStyles[variant]}`}>
      {label && <div className={sharedStyles.inputLabel}>{label}</div>}
      <textarea
        ref={inputRef}
        id={textareaId}
        className={`
          ${sharedStyles.input} ${className || ''}
          ${showScrollbar ? sharedStyles.scrollable : ''} 
        `}
        value={value}
        name={name || 'Tour App Text Area Input'}
        onChange={(event) => onChange(event.target.value)}
        rows={rows}
      />
    </div>
  );
}

export default TextAreaInput;
